import { Location } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { toSignal } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { CommonComponentsModule } from '../../../commons/components/common-components.module';
import { EErrorCode } from '../../../commons/entities/error-code';
import { NavigationService } from '../../../commons/services/navigation.service';
import { StoreService } from '../../../commons/stores/store.service';
import { TvLoginStore } from '../../app/services/app.store';
import { errors } from './error.model';

@Component({
  selector: 'error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  imports: [TranslateModule, CommonComponentsModule],
})
export class ErrorComponent {
  readonly tvLoginStore = inject(TvLoginStore);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly translateService = inject(TranslateService);
  private readonly navigationService = inject(NavigationService);
  private readonly storeService = inject(StoreService);
  private readonly route = inject(ActivatedRoute);
  private readonly location = inject(Location);
  private readonly queryParamLogoutUrl = toSignal(
    this.route.queryParams.pipe(map((queryParams) => queryParams.logoutUrl))
  );

  showSpinner = false;
  currentError = toSignal(this.route.params.pipe(map((params) => errors[params['code']])));

  is500InternalError = computed(() => this.currentError()?.id === errors[EErrorCode.Error_500_server_error].id);

  sanitizeHtml(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  onButtonClick() {
    switch (this.currentError().id) {
      case errors[EErrorCode.Error_TC_invalid_version].id:
        const clientAlias = this.storeService?.loginResponse?.clientAlias ?? this.tvLoginStore.getLoginAlias();
        this.navigationService.goToTermsAndConditions(clientAlias, this.storeService.termsParams);
        break;

      case errors[EErrorCode.Error_0_offline].id:
        if (window.navigator.onLine) {
          this.location.back();
        } else {
          this.emulateRetry();
        }
        break;

      case errors[EErrorCode.Error_Account_Is_Not_Reachable].id:
      case errors[EErrorCode.Error_500_server_error].id:
        if (this.queryParamLogoutUrl()) {
          window.open(this.queryParamLogoutUrl(), '_blank');
        }

        this.navigationService.goToMonolith(); // if once more errors requires redirect to monolith - make it default
        break;

      default:
        this.navigationService.backToLoginFromExternal();
        break;
    }
  }

  private emulateRetry() {
    this.showSpinner = true;
    setTimeout(() => (this.showSpinner = false), 800);
  }
}
